import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ulcer-index-calculator',
  component: () => import('../../routes/UlcerIndexCalculator.svelte'),
  card: {
    id: 'ulcer-index',
    title: 'Ulcer Index',
    description: 'Measure downside investment risk by calculating the depth and duration of drawdowns from peak values.',
    icon: 'downhill',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/ulcer-index-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Ulcer Index Calculator – Measure Downside Investment Risk',
    description: 'Free Ulcer Index calculator measures downside volatility from drawdowns. Understand how deeply and often your portfolio dips from its peak.',
  },
};

export default meta;
